import { Input } from '@/components/ui'
import SectionForm, { getFormField, useFormContext } from "../SectionForm"
import { useBienContext } from '../BienContext'

const FieldList = [
  // Partie 1
  {name: "copropriete_numero_lot", label: "Numéro de lot", type: "text"},
  {name: "copropriete_montant_charges", label: "Montant des charges", type: "currency"},
  {name: "copropriete_detail_charges", label: "Détail des charges", type: "text"},
  {name: "copropriete_date_derniere_ag", label: "Date dernière AG", type: "date"},
  // Partie 2
  {name: "copropriete_syndic_nom", label: "Nom du syndic", type: "text"},
  {name: "copropriete_syndic_compte", label: "Accès compte Syndic", type: "textarea" },
  // Partie 3
  {name: "copropriete_divers", label: "Divers", type: "textarea",
    hint: "(gardien, interphone, espaces verts, ... etc)"
  },
]

// typeBien est passé en props car SectionForm
// ne crée les values dans le form que pour les fields définis
const FormContent = ({fields, item}) => {
  const { control, formErrors, errors } = useFormContext()
  return (
    <>
      <div className="flex flex-col items-start gap-4">                
        { fields.slice(0,4).map(
          (field, index) => getFormField(control, field, index) 
        )}
        <Input.File control={control}
          name="reglement_copropriete_file"
          label="Règlement copro."
          defaultValue={item.reglement_copropriete_file?.filename || '' }
          inputProps={{accept: ".pdf"}}
          canDelete={true}
        />
      </div>
      <div className="flex flex-col items-start gap-4">                
        { fields.slice(4,6).map(
          (field, index) => getFormField(control, field, index) 
        )}
      </div>
      <div className="flex flex-col items-start gap-4">                
        {getFormField(control, FieldList[6], 6) }
      </div>
    </>
  )
}

const Form = ({ title = "", onClose = () => {}, onSuccess = () => {} }) => {
  const { bien } = useBienContext()

  return (
    <SectionForm
      title={title}
      onClose={onClose}
      onSuccess={onSuccess}
      fields={[...FieldList.map( f => f.name), "reglement_copropriete_file"]}
    >
      <FormContent fields={FieldList} item={bien} />
    </SectionForm>
  )
}

export default Form